
import React from 'react';
import { ShieldCheck, Users, Trophy, Heart } from 'lucide-react';
import Layout from '../components/Layout';
import { ASSETS } from '../data';

const OmOs = () => {
  return (
    <Layout>
      <section className="pt-56 pb-24 bg-slate-900 overflow-hidden relative">
        <div className="absolute top-1/2 left-0 w-full h-px bg-white/5 -z-0"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-[2rem] md:text-7xl font-bold text-white tracking-tighter mb-6">OM OS</h1>
            <p className="text-amber-500 font-bold tracking-[0.3em] uppercase">Mød holdet bag Jensen & Sørensen ApS</p>
          </div>
        </div>
      </section>

      {/* Team Image Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-20">
            <div className="relative aspect-video shadow-2xl overflow-hidden group">
              <img 
                src={ASSETS.team} 
                alt="Jensen & Sørensen Team" 
                className="w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 transition-all duration-700"
              />
              <div className="absolute inset-0 border-[20px] border-white/10 pointer-events-none"></div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-start">
            <div>
              <h2 className="text-3xl font-bold text-slate-900 mb-6 leading-tight uppercase tracking-tight">
                VI BYGGER PÅ <span className="text-amber-500">TILLID OG KVALITET</span>
              </h2>
              <div className="space-y-6 text-slate-600 leading-relaxed font-light text-lg">
                <p>
                  Vi er Jensen & Sørensen ApS, et håndværksfirma grundlagt på vores livslange venskab og fælles passion for tømrerfaget. Vi, Mark og Simon, har kendt hinanden siden barndommen, hvor vi tilbragte utallige timer sammen i vores fædres værksteder. Vores venskab er vokset sig stærkere gennem årene, og med tiden har vi udviklet vores færdigheder og ekspertise inden for tømrerarbejde.
                </p>
                <p>
                  Med over 15 års samlet erfaring i byggebranchen, tilbyder vi en bred vifte af tjenester inden for byggeri og renovering. Vores kompetencer spænder fra traditionelle tømreropgaver som tagkonstruktioner og gulvlægning til moderne løsninger inden for energirenovering og specialtilpassede løsninger.
                </p>
                <p>
                  Hver opgave bliver udført med stor omhu og opmærksomhed på detaljer, og vi går aldrig på kompromis med kvaliteten. Vi værdsætter den personlige kontakt og den tætte dialog med vores kunder, og vi stræber efter at levere skræddersyede løsninger, der opfylder individuelle behov og drømme.
                </p>
                <p>
                  Vores virksomhed er bygget på tillid, integritet og håndværksmæssig stolthed. Vi mener, at et solidt stykke håndværk starter med et solidt fundament – både i vores arbejde og i vores relationer med kunder og samarbejdspartnere.
                </p>
                <p>
                  Hos Jensen & Sørensen ApS kan du forvente professionel rådgivning, pålidelig service og et resultat, der lever op til dine forventninger. Kontakt os i dag for et uforpligtende tilbud, og oplev forskellen ved at arbejde med et team, der er lige så engagerede i dit projekt som du er.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              <div className="p-8 bg-slate-50 border-l-4 border-amber-500">
                <ShieldCheck className="text-amber-500 mb-4" size={32} />
                <h4 className="font-bold text-slate-900 mb-2 uppercase tracking-tight">Byg Garanti</h4>
                <p className="text-slate-500 text-sm">Din sikkerhed for veludført arbejde og økonomisk tryghed under hele byggeriet.</p>
              </div>
              <div className="p-8 bg-slate-50 border-l-4 border-amber-500">
                <Users className="text-amber-500 mb-4" size={32} />
                <h4 className="font-bold text-slate-900 mb-2 uppercase tracking-tight">Direkte dialog</h4>
                <p className="text-slate-500 text-sm">Ingen mellemmænd. Du taler direkte med os, der udfører arbejdet.</p>
              </div>
              <div className="p-8 bg-slate-50 border-l-4 border-amber-500">
                <Trophy className="text-amber-500 mb-4" size={32} />
                <h4 className="font-bold text-slate-900 mb-2 uppercase tracking-tight">Erfaring</h4>
                <p className="text-slate-500 text-sm">Mange års erfaring med alt fra mindre reparationer til store nybyggerier.</p>
              </div>
              <div className="p-8 bg-slate-50 border-l-4 border-amber-500">
                <Heart className="text-amber-500 mb-4" size={32} />
                <h4 className="font-bold text-slate-900 mb-2 uppercase tracking-tight">Passion</h4>
                <p className="text-slate-500 text-sm">Vi elsker træ, og vi elsker at skabe resultater, der gør en forskel for vores kunder.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-24 bg-slate-900">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-4xl md:text-5xl font-bold text-white tracking-tighter leading-none mb-8 italic opacity-20">"</p>
          <h3 className="text-2xl md:text-3xl font-light text-white leading-relaxed mb-10">
            Byggeri handler ikke kun om mursten og træ, men om at skabe rammerne for menneskers liv og drømme. Det ansvar tager vi meget seriøst hver dag.
          </h3>
          <p className="text-amber-500 font-bold tracking-widest uppercase text-sm">— Mark Jensen & Simon Sørensen</p>
        </div>
      </section>
    </Layout>
  );
};

export default OmOs;
